import React from 'react';
import Grid from 'atoms/Layout/Grid/Grid';
import SectionLayout from 'atoms/Layout/Section/SectionLayout';
import Stack from 'atoms/Layout/Stack/Stack';
import CommunityDesignFeed from 'organisms/Homepage/CommunityDesignFeed/CommunityDesignFeed';
import CommunityDesignTextBlock from 'organisms/Homepage/CommunityDesignTextBlock/CommunityDesignTextBlock';

const CommunityDesign = (): JSX.Element => (
  <SectionLayout
    maxWidth='width-3xl'
    padding={['spacing-7xl', 'spacing-none']}
    paddingSm={['spacing-4xl', 'spacing-none']}
  >
    <Grid
      padding={['spacing-none', 'spacing-4xl']}
      paddingSm={['spacing-none', 'spacing-xl']}
      gap='spacing-7xl'
      gapXl='spacing-3xl'
    >
      <Stack
        justify='flex-start'
        align='flex-start'
        columns={4}
        columnsXl={12}
      >
        <CommunityDesignTextBlock />
      </Stack>
      <Stack
        columns={8}
        columnsXl={12}
      >
        <CommunityDesignFeed />
      </Stack>
    </Grid>
  </SectionLayout>
);

export default CommunityDesign;
